import {
  EditorState,
} from 'draft-js';

import {
  Tooltip,
} from 'web-components';

import { BoldIcon, ItalicIcon } from './Icons';
import * as S from '../styled';

interface Props {
  editorState: EditorState
  onToggle: { (style: string): void }
}

const InlineStyle = ({
  editorState,
  onToggle,
}: Props) => {
  const INLINE_STYLES = [
    {
      icon: BoldIcon,
      style: 'BOLD',
      tooltip: 'Bold (Ctrl+B)',
    },
    {
      icon: ItalicIcon,
      style: 'ITALIC',
      tooltip: 'Italic (Ctrl+I)',
    },
  ];

  const currentStyle = editorState.getCurrentInlineStyle();
  return INLINE_STYLES.map(type => (
    <Tooltip
      key={type.style}
      body={type.tooltip}
      positions={['top']}
    >
      <S.Control
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onToggle(type.style);
        }}
        isActive={currentStyle.has(type.style)}
      >
        <type.icon />
      </S.Control>
    </Tooltip>
  ));
};

export default InlineStyle;
